export const delay = (timeout = 10) =>
    new Promise<void>((resolve) => {
        setTimeout(() => {
            resolve();
        }, timeout);
    });

export const whenTruthy = async (condition, maxIterations = 1000, delayTimeout = 10) => {
    let count = 0;
    while (!condition() && count < maxIterations) {
        count += 1;

        // eslint-disable-next-line no-await-in-loop
        await delay(delayTimeout);
    }
};
